module.exports = __webpack_public_path__ + "media/images/paisley-23200e88b381daf0194a0c3678099328.png";